/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, ModalContent, Pagination, Select, SelectItem, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip } from '@nextui-org/react';
import { IconPlus, IconEdit } from '@tabler/icons-react';
import toast from 'react-hot-toast';
import { Constants, transformScheduleToRender } from '../../../utils';
import { IconTeacher } from '../../../assets/icons';
// import { UsersService } from '../../../services';
import { SchoolService } from '../../../services';
import ModalCreateSchedule from './create-schedule';
import { useDispatch, useSelector } from 'react-redux';

const MODAL_ACTION = {
  NONE: 0,
  CREATE: 1,
  VIEW: 2,
  EDIT: 3,
  DELETE: 4,
}

const Schedules = () => {
  const dispatch = useDispatch()
  const [selectedItem, setSelectedItem] = useState();
  const [modalAction, setModalAction] = useState(MODAL_ACTION.NONE);
  const { canResetFilter, data, filterBy, filters, goToPage, grades, isLoading, pagination, reload, schoolYears, clearFilters } = useFetchTable();

  const onSelectItem = (item, action) => {
    setSelectedItem(item);
    setModalAction(action);
  }

  const closeModal = (reloading = false) => {
    setSelectedItem(null);
    setModalAction(MODAL_ACTION.NONE);
    if (reloading) reload();
    dispatch({ type: 'REMOVE_DATA' });
  }

  return (
    <div>
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Modal
        size="5xl"
        isOpen={modalAction !== MODAL_ACTION.NONE}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            if (modalAction === MODAL_ACTION.CREATE) return (
              <ModalCreateSchedule
                onClose={onClose}
                onSuccess={() => closeModal(true)}
                grades={grades}
                schoolYears={schoolYears}
              />
            );
            if (modalAction === MODAL_ACTION.EDIT) return (
              <ModalCreateSchedule
                onClose={onClose}
                onSuccess={() => closeModal(true)}
                grades={grades}
                schoolYears={schoolYears}
                item={selectedItem}
              />
            );
          }}
        </ModalContent>
      </Modal>

      <Filters
        canResetFilter={canResetFilter}
        filterBy={filterBy}
        resetFilter={clearFilters}
        grades={grades}
        schoolYears={schoolYears}
      />

      <Table
        aria-label="Horarios Creados"
        color="primary"
        topContentPlacement="inside"
        topContent={
          <>
            <div className="flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium">Horarios Creados</h3>
              <Button
                className="pr-2 bg-green font-medium text-white"
                endContent={<IconPlus color="white" />}
                onClick={() => onSelectItem(null, MODAL_ACTION.CREATE)}
              >
                Nuevo
              </Button>
            </div>
            {!!filters._searchBlock && (
              <div className="bg-default-100 text-foreground-500 py-2 px-3 text-lg font-medium rounded-xl flex flex-row justify-between">
                <span>{filters._searchBlock}</span>
              </div>
            )}
          </>
        }
      >
        <TableHeader>
          <TableColumn hidden></TableColumn>
        </TableHeader>
        <TableBody
          items={data}
          emptyContent={(!isLoading && !!filters.schoolYear && !!filters.school_grade_id)
            ? 'No hay resultados'
            : 'Utilice los filtros de búsqueda para visualizar los horarios'
          }
        >
          {(item) => (
            <TableRow>
              <TableCell colSpan={4} className="p-0 bg-default-100 rounded-xl overflow-hidden mt-20">
                <div className="bg-default-100 text-foreground-500 py-2 px-3 text-xl font-bold flex flex-row justify-between">
                  <span className='capitalize'>{item.name}</span>
                </div>

                <div>
                  {item.sections.map(section => (
                    <>
                      <div key={section.id} className='flex py-2 text-lg px-3 flex-row items-center gap-2'>
                        <span className='capitalize mr-auto'>{section.name}</span>
                        <Tooltip content="Editar">
                          <IconEdit onClick={() => onSelectItem(section, MODAL_ACTION.EDIT)} />
                        </Tooltip>
                      </div>
                      <Table
                        className='border-spacing-14'
                        aria-label="Materias"
                        classNames={{ wrapper: 'p-0 border-0 shadow-none' }}
                      >
                        <TableHeader>
                          <TableColumn>Hora inicio</TableColumn>
                          <TableColumn>Hora fin</TableColumn>
                          <TableColumn>Lunes</TableColumn>
                          <TableColumn>Martes</TableColumn>
                          <TableColumn>Miércoles</TableColumn>
                          <TableColumn>Jueves</TableColumn>
                          <TableColumn>Viernes</TableColumn>
                        </TableHeader>
                        <TableBody items={section?.schedulers ?? []} emptyContent="No hay horarios">
                          {(schedule, i) => (
                            <TableRow key={schedule.from}>
                              <TableCell>{schedule.formatted_from_time}</TableCell>
                              <TableCell>{schedule.formatted_to_time}</TableCell>
                              <TableCell>
                                <SubjectTip
                                  subject={schedule.lunes?.name}
                                  teachers={schedule.lunes?.subject_professors}
                                  sectionId={section.id}
                                />
                              </TableCell>
                              <TableCell>
                                <SubjectTip
                                  subject={schedule.martes?.name}
                                  teachers={schedule.martes?.subject_professors}
                                  sectionId={section.id}
                                />
                              </TableCell>
                              <TableCell>
                                <SubjectTip
                                  subject={schedule.miercoles?.name}
                                  teachers={schedule.miercoles?.subject_professors}
                                  sectionId={section.id}
                                />
                              </TableCell>
                              <TableCell>
                                <SubjectTip
                                  subject={schedule.jueves?.name}
                                  teachers={schedule.jueves?.subject_professors}
                                  sectionId={section.id}
                                />
                              </TableCell>
                              <TableCell>
                                <SubjectTip
                                  subject={schedule.viernes?.name}
                                  teachers={schedule.viernes?.subject_professors}
                                  sectionId={section.id}
                                />
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </>
                  ))}
                </div>



              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
}

const SubjectTip = ({ subject = 'Libre', teachers = [], sectionId }) => {
  if (subject === 'Libre') return <span className="cursor-default">{subject}</span>;

  const filteredTeachers = teachers.filter((professor) =>
    professor?.professor?.school_sections?.some((section) => section.school_section_id === sectionId)
  );

  if (filteredTeachers.length === 0) {
    return (
      <Tooltip
        content={
          <div className="flex justify-center items-center gap-2">
            <img className="w-5 h-5 object-contain" src={IconTeacher} alt="Profesor" />
            <span>Sin profesor asignado</span>
          </div>
        }
      >
        <span className="cursor-default">{subject}</span>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      content={
        <div className="flex flex-col gap-2">
          {filteredTeachers.map((professor) => (
            <div key={professor.professor_id} className="flex items-center gap-2">
              <img className="w-5 h-5 object-contain" src={IconTeacher} alt="Profesor" />
              {professor.professor?.name} {professor.professor?.lastname}
            </div>
          ))}
        </div>
      }
    >
      <span className="cursor-default">{subject}</span>
    </Tooltip>
  );
};

const Filters = ({ canResetFilter, filterBy, grades, resetFilter, schoolYears }) => {
  const initialFilter = {
    school_year_id: '',
    school_grade_id: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  const filterGrades = useMemo(() => {
    return grades.filter(x => x.school_year_id === +form.school_year_id);
  }, [form.school_year_id])



  return (
    <section className="mb-4 grid sm:flex grid-cols-2 lg:flex-row items-end gap-4">
      <Select
        label="Año escolar"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          base: 'w-full sm:max-w-[15rem]',
          inputWrapper: 'border-1 h-10',
          label: 'font-semibold',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_year_id ? [form.school_year_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_year_id')}
      >
        {schoolYears.map((item) => (
          <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
        ))}
      </Select>
      <Select
        label="Grado"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          base: 'w-full sm:max-w-[15rem]',
          inputWrapper: 'border-1 h-10',
          label: 'font-semibold',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_grade_id ? [form.school_grade_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_grade_id')}
      >
        {filterGrades.map((item) => (
          <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
        ))}
      </Select>

      {canResetFilter && (
        <Button
          variant="light"
          className="text-primaryDark"
          onClick={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )
}

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    since: null,
    until: null,
    school_year_id: '',
    school_grade_id: '',
    _searchBlock: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const user = useSelector(state => state.user);
  const [data, setData] = useState([]);
  const [schoolYears, setSchoolYears] = useState([]);
  const [grades, setGrades] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);


  const fetchSelects = async () => {
    try {
      const gradesData = await SchoolService.schoolAdmin.getGrades({ school_id: user.id });
      const schoolYearsRes = await SchoolService.schoolAdmin.getSchoolarsYears();
      setSchoolYears(schoolYearsRes);
      setGrades(gradesData);
      setCanFetch(true)

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const fetchData = async () => {
    const { school_year_id } = filters;
    if (!canFetch || !school_year_id) return;
    setCanFetch(false);

    try {
      const res = await SchoolService.schoolAdmin.getSchedulers({ ...filters, school_id: user.id })
      // Transformamos la data del backend para mostrarla
      const transformData = res.data.map((item) => {
        return {
          ...item,
          sections: item.sections.map((section) => ({
            ...section,
            schedulers: transformScheduleToRender(section.schedulers)
          }))
        }
      })

      setData(transformData)
      setCanFetch(true);
    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const getCurrentPagination = () => {
    // Truco para obtener el estado actualizado (pagination es mantenida con el estado actual por el componente Pagination)
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const canResetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    fetchData();
  }

  const clearFilters = () => {
    setFilters(initialFilters)
    setData([])
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const filterBy = (value, target) => {
    setCanFetch(true);
    const _filter = { ...filters, page: 1, [target]: value };
    const schoolYear = schoolYears.find(x => x.value === _filter.schoolYear)?.label;
    const grade = grades.find(x => x.value === _filter.school_grade_id)?.label;
    setFilters({
      ..._filter,
      _searchBlock: (!!schoolYear && !!grade) ? `${grade} Grado (${schoolYear})` : '',
    });
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    fetchSelects();
  }, []);

  return {
    canResetFilter: canResetFilter(),
    changePerPage,
    data,
    filterBy,
    filters,
    goToPage,
    grades,
    isLoading: !canFetch,
    pagination,
    reload,
    schoolYears,
    clearFilters
  }
}

export default Schedules;
